var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerizon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.772 0.730011H2.25801C1.01924 0.730011 0.0150146 1.73423 0.0150146 2.973V14.487C0.0150146 15.7258 1.01924 16.73 2.25801 16.73H13.772C15.0108 16.73 16.015 15.7258 16.015 14.487V2.973C16.015 1.73423 15.0108 0.730011 13.772 0.730011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1213 2.78607L6.61088 12.4265L4.91476 8.77367H3.08044L5.86962 14.7487H7.35215L12.943 2.78607H11.1213Z",
    fill: "#EE0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerizon);
export default __webpack_public_path__ + "static/media/Verizon.5aa14df1e7ca674f56d87a5068d489eb.svg";
export { ForwardRef as ReactComponent };